import { createClient } from '@/shared/api';
import UPDATE_HOLTER_PROFILE_MUTATION from '@/entities/study/api/mutations/updateHolterProfile';
import type {
  UpdateHolterProfileMutation,
  UpdateHolterProfileMutationVariables,
} from '@/shared/api/generated/graphql';

export type UpdateHolterProfileResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the UpdateHolterProfileInput GraphQL input once its server-side shape is documented
/**
 * Saves changes to a study's holter profile. Runs the updateHolterProfile mutation and throws the server message when it reports failure.
 *
 * @param input - Mutation input carrying the profile changes.
 * @returns A promise resolving once the holter profile has been saved.
 */
const handleUpdateHolterProfile = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<
    UpdateHolterProfileMutation,
    UpdateHolterProfileMutationVariables
  >({
    mutation: UPDATE_HOLTER_PROFILE_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { updateHolterProfile } = data;
  if (!updateHolterProfile.isSuccess) {
    throw new Error(updateHolterProfile.message);
  }
};

export default handleUpdateHolterProfile;
